(function() {
  const storeLocatorPageRoot = document.getElementById('store-locator-root');
  if (!storeLocatorPageRoot) return;

  function readStoreLocatorRootDataAttr(attributeName, fallback) {
    const v = String(storeLocatorPageRoot.getAttribute(attributeName) || '').trim();
    return v !== '' ? v : fallback;
  }
  const OPENING_SOON_BADGE_LABEL = readStoreLocatorRootDataAttr(
    'data-opening-soon-badge-label',
    'Opening Soon'
  );
  const OPENING_SOON_HOURS_DEFAULT = readStoreLocatorRootDataAttr(
    'data-opening-soon-hours-default',
    'Varies by sailing schedule'
  );

  const prevGmAuthFailure = window.gm_authFailure;
  window.gm_authFailure = function() {
    if (typeof prevGmAuthFailure === 'function') prevGmAuthFailure();
    const googleMapContainer = document.getElementById('store-locator-map');
    if (!googleMapContainer || googleMapContainer.getAttribute('data-gm-auth-error') === '1') return;
    googleMapContainer.setAttribute('data-gm-auth-error', '1');
    googleMapContainer.classList.add('store-locator-map--error');
    googleMapContainer.innerHTML =
      '<div class="store-locator-map-error" role="alert">' +
      '<p class="store-locator-map-error__title">Google Maps could not load</p>' +
      '<p class="store-locator-map-error__text">Open the browser developer console (F12) for Google\'s error code. Common fixes: turn on billing for the Cloud project, enable the <strong>Maps JavaScript API</strong>, and under key restrictions allow HTTP referrers such as <code>https://your-domain.com/*</code>, <code>https://*.myshopify.com/*</code>, and your theme preview URL if you use <code>shopify theme dev</code>.</p>' +
      '</div>';
  }; 

  const storesDataNode = document.getElementById('store-locator-data');
  let stores = [];
  const fallbackStores = [
    {
      id: 'demo-dubai-marina',
      name: 'DI Diamonds - Dubai Marina',
      handle: 'dubai-marina',
      address: 'Marina Walk, Shop 14\nDubai Marina, Dubai',
      country: 'United Arab Emirates',
      latitude: 25.0804,
      longitude: 55.1403,
      image: 'https://placehold.co/720x450/f2f2f2/333333?text=Dubai+Marina',
      phone: '+971 4 555 1101',
      email: 'marina@didiamonds.com',
      hours: 'Mon-Sat: 10:00 AM - 9:00 PM',
      description: '<p>A flagship showroom in Dubai Marina featuring curated diamond jewelry collections and private consultation services.</p>'
    },
    {
      id: 'demo-london-mayfair',
      name: 'DI Diamonds - London Mayfair',
      handle: 'london-mayfair',
      address: '12 Berkeley Square\nMayfair, London W1J 6BS',
      country: 'United Kingdom',
      latitude: 51.5097,
      longitude: -0.1463,
      image: 'https://placehold.co/720x450/f5f5f5/333333?text=London+Mayfair',
      phone: '+44 20 7946 8812',
      email: 'mayfair@didiamonds.com',
      hours: 'Mon-Fri: 9:00 AM - 7:00 PM',
      description: '<p>Our Mayfair boutique offers personalized diamond selection and bespoke jewelry design appointments.</p>'
    },
    {
      id: 'demo-mumbai-bkc',
      name: 'DI Diamonds - Mumbai BKC',
      handle: 'mumbai-bkc',
      address: 'Plot C-70, Bandra Kurla Complex\nMumbai, Maharashtra 400051',
      country: 'India',
      latitude: 19.0607,
      longitude: 72.8685,
      image: 'https://placehold.co/720x450/ededed/333333?text=Mumbai+BKC',
      phone: '+91 22 6810 2400',
      email: 'bkc@didiamonds.com',
      hours: 'Mon-Sat: 10:30 AM - 8:30 PM',
      description: '<p>Located in BKC, this showroom provides an exclusive in-store experience for bridal and luxury collections.</p>'
    },
    {
      id: 'demo-singapore-marina-bay',
      name: 'DI Diamonds - Marina Bay',
      handle: 'singapore-marina-bay',
      address: '8 Bayfront Avenue\nSingapore 018955',
      country: 'Singapore',
      latitude: 1.2823,
      longitude: 103.8585,
      image: 'https://placehold.co/720x450/efefef/333333?text=Marina+Bay',
      phone: '+65 6688 9030',
      email: 'marinabay@didiamonds.com',
      hours: 'Daily: 10:00 AM - 10:00 PM',
      description: '<p>Marina Bay showroom features global diamond collections and premium concierge shopping services.</p>'
    },
    {
      id: 'demo-new-york-soho',
      name: 'DI Diamonds - Soho',
      handle: 'new-york-soho',
      address: '135 Prince Street\nSoho, New York, NY 10012',
      country: 'United States',
      latitude: 40.7242,
      longitude: -74.0018,
      image: 'https://placehold.co/720x450/f3f3f3/333333?text=New+York+Soho',
      phone: '+1 212 555 0199',
      email: 'soho@didiamonds.com',
      hours: 'Mon-Sun: 11:00 AM - 8:00 PM',
      description: '<p>In the heart of Soho, explore signature cuts and custom engagement ring experiences.</p>'
    },
    {
      id: 'demo-paris-vendome',
      name: 'DI Diamonds - Place Vendome',
      handle: 'paris-vendome',
      address: '23 Place Vendome\n75001 Paris',
      country: 'France',
      latitude: 48.8674,
      longitude: 2.3295,
      image: 'https://placehold.co/720x450/f1f1f1/333333?text=Paris+Vendome',
      phone: '+33 1 83 62 74 50',
      email: 'vendome@didiamonds.com',
      hours: 'Mon-Sat: 10:00 AM - 7:30 PM',
      description: '<p>Our Paris location at Place Vendome offers timeless high-jewelry creations and private viewings.</p>'
    },
    {
      id: 'demo-paris-vendome2',
      name: 'DI Diamonds - Place Vendome 2',
      handle: 'paris-vendome-2',
      address: '23 Place Vendome\n75001 Paris',
      country: 'France',
      latitude: 48.8674,
      longitude: 2.3295,
      image: 'https://placehold.co/720x450/f1f1f1/333333?text=Paris+Vendome',
      phone: '+33 1 83 62 74 50',
      email: 'vendome@didiamonds.com',
      hours: 'Mon-Sat: 10:00 AM - 7:30 PM',
      description: '<p>Our Paris location at Place Vendome offers timeless high-jewelry creations and private viewings.</p>'
    }
  ];
  try {
    stores = JSON.parse(storesDataNode ? storesDataNode.textContent : '[]');
  } catch (e) {
    stores = [];
  }
  const fromPageMetafield =
    storesDataNode && storesDataNode.getAttribute('data-source') === 'page-metafield';
  if ((!Array.isArray(stores) || !stores.length) && !fromPageMetafield) {
    stores = fallbackStores;
  }
  if (!Array.isArray(stores)) {
    stores = [];
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getSiteLogoImageUrlFromDom() {
    const headerLogoImg = document.querySelector('.site-header__logo-image img');
    if (!headerLogoImg) return '';
    const urlCandidate =
      headerLogoImg.currentSrc ||
      headerLogoImg.getAttribute('src') ||
      headerLogoImg.getAttribute('data-src') ||
      '';
    const trimmed = String(urlCandidate || '').trim();
    if (!trimmed || trimmed.indexOf('data:') === 0) return '';
    return trimmed;
  }
  const STORE_IMAGE_LOGO_FALLBACK = getSiteLogoImageUrlFromDom();

  const BOOK_APPOINTMENT_SUBJECT = 'Book an appointment';

  function buildBookAppointmentMailto(email) {
    const trimmedEmailAddress = String(email || '').trim();
    return (
      'mailto:' + trimmedEmailAddress + '?subject=' + encodeURIComponent(BOOK_APPOINTMENT_SUBJECT)
    );
  }

  function replaceModalNavigationLink(linkEl, href) {
    if (!linkEl || !linkEl.parentNode) return linkEl;
    const freshLink = linkEl.cloneNode(true);
    freshLink.setAttribute('href', href);
    linkEl.parentNode.replaceChild(freshLink, linkEl);
    return freshLink;
  }

  function resolveStoreCollectionUrl(rawUrl) {
    const trimmed = String(rawUrl || '').trim();
    if (!trimmed) return '/collections/all';
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    if (trimmed.charAt(0) === '/') return trimmed;
    if (/^collections\//i.test(trimmed)) {
      return '/' + trimmed.replace(/^\/+/, '');
    }
    return '/collections/' + trimmed.replace(/^\/+/, '');
  }

  function applyModalHeroCollectionLink(collectionUrl) {
    const heroCta = document.getElementById('store-detail-hero-cta');
    if (!heroCta) return;
    replaceModalNavigationLink(
      heroCta,
      resolveStoreCollectionUrl(collectionUrl)
    );
  }

  function applyModalAppointmentLink(email) {
    const appointmentLink = document.getElementById('store-detail-appointment-link');
    if (!appointmentLink) return;
    const freshLink = replaceModalNavigationLink(
      appointmentLink,
      buildBookAppointmentMailto(email)
    );
    if (freshLink) {
      freshLink.removeAttribute('aria-disabled');
      freshLink.removeAttribute('tabindex');
    }
  }

  function parseCoord(value) {
    if (value == null || value === '') return NaN;
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : NaN;
    }
    if (typeof value === 'object' && value !== null && 'value' in value) {
      return parseCoord(value.value);
    }
    const normalizedCoordString = String(value)
      .trim()
      .replace(/\s/g, '')
      .replace(/,/g, '.');
    const parsedCoordinate = parseFloat(normalizedCoordString);
    return Number.isFinite(parsedCoordinate) ? parsedCoordinate : NaN;
  }

  /** Place pin inside a Google Maps listing URL (`!3d…!4d…`) — aligns with Google's business centroid. Fallback: `@viewport` centre. */
  function parseGoogleMapsPlacePinCoordinates(rawUrl) {
    if (rawUrl == null) return null;
    const trimmedUrl = String(rawUrl).trim();
    if (!trimmedUrl) return null;
    const placePinPairRegex = /!3d(-?\d+(?:\.\d+)?)!4d(-?\d+(?:\.\d+)?)/g;
    let lastLatLng = null;
    let matchedPair;
    while ((matchedPair = placePinPairRegex.exec(trimmedUrl)) !== null) {
      const placeLat = parseFloat(matchedPair[1]);
      const placeLng = parseFloat(matchedPair[2]);
      if (Number.isFinite(placeLat) && Number.isFinite(placeLng)) {
        lastLatLng = { lat: placeLat, lng: placeLng };
      }
    }
    return lastLatLng;
  }

  /** Map viewport centre from `@lat,lng` — only where you were pointing, not necessarily the business. */
  function parseGoogleMapsViewportCoordinates(rawUrl) {
    if (rawUrl == null) return null;
    const trimmedUrl = String(rawUrl).trim();
    if (!trimmedUrl) return null;
    const viewportCoordMatch = trimmedUrl.match(/@(-?\d+(?:\.\d+)?),(-?\d+(?:\.\d+)?)/);
    if (viewportCoordMatch) {
      const viewportLat = parseFloat(viewportCoordMatch[1]);
      const viewportLng = parseFloat(viewportCoordMatch[2]);
      if (Number.isFinite(viewportLat) && Number.isFinite(viewportLng)) {
        return { lat: viewportLat, lng: viewportLng };
      }
    }
    return null;
  }

  function unwrapStoreFieldValue(value) {
    if (value == null) return '';
    if (typeof value === 'object') {
      if ('value' in value) return unwrapStoreFieldValue(value.value);
      if ('url' in value) return unwrapStoreFieldValue(value.url);
      return '';
    }
    return String(value).trim().replace(/^['"]|['"]$/g, '');
  }

  function normalizeGoogleMapsUrl(rawUrl) {
    let trimmedUrl = unwrapStoreFieldValue(rawUrl);
    if (!trimmedUrl) return '';
    if (!/^https?:\/\//i.test(trimmedUrl)) {
      if (/^\/\//.test(trimmedUrl)) {
        trimmedUrl = 'https:' + trimmedUrl;
      } else if (
        /^(www\.)?google\.[\w.]+\/maps/i.test(trimmedUrl) ||
        /^maps\.google\./i.test(trimmedUrl) ||
        /^maps\.app\.goo\.gl\//i.test(trimmedUrl) ||
        /^goo\.gl\/maps\//i.test(trimmedUrl)
      ) {
        trimmedUrl = 'https://' + trimmedUrl.replace(/^\/\//, '');
      } else {
        return '';
      }
    }
    if (
      !/google\.[\w.]+\/maps/i.test(trimmedUrl) &&
      !/maps\.google\./i.test(trimmedUrl) &&
      !/maps\.app\.goo\.gl/i.test(trimmedUrl) &&
      !/goo\.gl\/maps/i.test(trimmedUrl)
    ) {
      return '';
    }
    return trimmedUrl;
  }

  function resolveDirectionsLinkFromRawStore(store) {
    return normalizeGoogleMapsUrl(
      store.google_direction_link ||
        store.google_directions_link ||
        store.directions_url
    );
  }

  function buildAddressFromMeta(store) {
    const streetLine1 = store.address_line_1;
    const streetLine2 = store.address_line_2;
    const cityCountryLineFromMeta = store.address_city_line;
    const hasStructured =
      (streetLine1 != null && String(streetLine1).trim() !== '') ||
      (streetLine2 != null && String(streetLine2).trim() !== '') ||
      (cityCountryLineFromMeta != null && String(cityCountryLineFromMeta).trim() !== '');
    if (hasStructured) {
      const structuredParts = [];
      if (streetLine1 != null && String(streetLine1).trim() !== '') structuredParts.push(String(streetLine1).trim());
      if (streetLine2 != null && String(streetLine2).trim() !== '') structuredParts.push(String(streetLine2).trim());
      if (cityCountryLineFromMeta != null && String(cityCountryLineFromMeta).trim() !== '') structuredParts.push(String(cityCountryLineFromMeta).trim());
      return structuredParts.join('\n');
    }
    if (store.address != null && String(store.address).trim() !== '') {
      return String(store.address).trim();
    }
    const parts = [];
    const line1 = store.address_line_1;
    const line2 = store.address_line_2;
    const city = store.city;
    const state = store.state_region;
    const country = store.country || store.country_name;
    if (line1) parts.push(String(line1).trim());
    if (line2) parts.push(String(line2).trim());
    let cityLine = '';
    if (city) {
      cityLine = String(city).trim();
      if (state) cityLine += ', ' + String(state).trim();
      if (country) cityLine += ', ' + String(country).trim();
    } else if (state || country) {
      cityLine = [state, country]
        .filter(Boolean)
        .map(function(regionPart) {
          return String(regionPart).trim();
        })
        .join(', ');
    }
    if (cityLine) parts.push(cityLine);
    return parts.join('\n');
  }

  function buildWeekHoursFromMeta(store) {
    const weekDayMap = [
      ['mon_hours', 'Monday'],
      ['tue_hours', 'Tuesday'],
      ['wed_hours', 'Wednesday'],
      ['thu_hours', 'Thursday'],
      ['fri_hours', 'Friday'],
      ['sat_hours', 'Saturday'],
      ['sun_hours', 'Sunday']
    ];
    const weekHourRows = [];
    let hasAnyDefinedHour = false;
    weekDayMap.forEach(function(metaFieldDayPair) {
      const hoursMetaFieldKey = metaFieldDayPair[0];
      const dayLabel = metaFieldDayPair[1];
      const hoursRaw = store[hoursMetaFieldKey];
      const trimmedHoursText = hoursRaw != null ? String(hoursRaw).trim() : '';
      if (trimmedHoursText !== '') {
        hasAnyDefinedHour = true;
        weekHourRows.push({ day: dayLabel, hours: trimmedHoursText });
      }
    });
    return hasAnyDefinedHour ? weekHourRows : null;
  }

  function formatOpeningDate(rawValue) {
    const trimmedRaw = rawValue == null ? '' : String(rawValue).trim();
    if (!trimmedRaw) return '';
    const isoDateMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(trimmedRaw);
    if (isoDateMatch) {
      const parsedDate = new Date(
        Number(isoDateMatch[1]),
        Number(isoDateMatch[2]) - 1,
        Number(isoDateMatch[3])
      );
      if (!isNaN(parsedDate.getTime())) {
        try {
          return parsedDate.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          });
        } catch (e) {
          /* fall through to raw */
        }
      }
    }
    if (/^\d{4}$/.test(trimmedRaw)) {
      return trimmedRaw;
    }
    const parsedMs = Date.parse(trimmedRaw);
    if (!Number.isNaN(parsedMs)) {
      const fromParsed = new Date(parsedMs);
      if (!Number.isNaN(fromParsed.getTime())) {
        try {
          return fromParsed.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          });
        } catch (e2) {
          /* fall through */
        }
      }
    }
    return trimmedRaw;
  }

  function normalizeBrandList(list) {
    const seenLowercaseKeys = {};
    const dedupedBrandNames = [];
    if (!Array.isArray(list)) return dedupedBrandNames;
    list.forEach(function(item) {
      let brandLabel =
        typeof item === 'string' ? item : item && (item.name || item.title);
      if (!brandLabel) return;
      brandLabel = String(brandLabel).trim();
      if (!brandLabel) return;
      const lowercaseKey = brandLabel.toLowerCase();
      if (seenLowercaseKeys[lowercaseKey]) return;
      seenLowercaseKeys[lowercaseKey] = true;
      dedupedBrandNames.push(brandLabel);
    });
    return dedupedBrandNames;
  }

  function brandEntryFromItem(item) {
    if (item == null) return null;
    if (typeof item === 'string') {
      const trimmedName = String(item).trim();
      return trimmedName ? { name: trimmedName, image: '' } : null;
    }
    let name = item.name || item.title;
    if (!name) return null;
    name = String(name).trim();
    if (!name) return null;
    let image = '';
    if (item.image != null && String(item.image).trim() !== '') {
      image = String(item.image).trim();
    }
    return { name: name, image: image };
  }

  /** Deduped list of { name, image } for modal / JSON from metaobjects. */
  function normalizeBrandEntries(list) {
    const seenNameKeys = {};
    const dedupedBrandEntries = [];
    if (!Array.isArray(list)) return dedupedBrandEntries;
    list.forEach(function(item) {
      const brandEntry = brandEntryFromItem(item);
      if (!brandEntry) return;
      const dedupeKey = brandEntry.name.toLowerCase();
      if (seenNameKeys[dedupeKey]) return;
      seenNameKeys[dedupeKey] = true;
      dedupedBrandEntries.push(brandEntry);
    });
    return dedupedBrandEntries;
  }

  function brandEntriesSearchString(entries) {
    if (!Array.isArray(entries)) return '';
    return entries
      .map(function(brandEntry) {
        if (typeof brandEntry === 'string') return brandEntry;
        return brandEntry && brandEntry.name ? String(brandEntry.name) : '';
      })
      .join(' ');
  }

  function normalizeForStoreSearch(value) {
    return String(value == null ? '' : value)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, ' and ')
      .replace(/[''`]/g, '')
      .replace(/\./g, ' ')
      .replace(/[,/\-–—]/g, ' ')
      .replace(/\bsaint\b/g, 'st')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function buildStoreSearchText(store) {
    return normalizeForStoreSearch(
      [
        store.name,
        store.country,
        store.region,
        store.groupName,
        store.locationName,
        store.address,
        (store.brands || []).join(' '),
        brandEntriesSearchString(store.jewelryBrands),
        brandEntriesSearchString(store.watchesBrands)
      ].join(' ')
    );
  }

  function storeSearchTextMatchesQuery(searchText, normalizedQuery) {
    if (!normalizedQuery) return true;
    if (searchText.indexOf(normalizedQuery) !== -1) return true;

    const queryTokens = normalizedQuery.split(' ').filter(Boolean);
    if (queryTokens.length <= 1) return false;

    return queryTokens.every(function(token) {
      return searchText.indexOf(token) !== -1;
    });
  }

  const SEARCH_VOCAB_STOP_WORDS = {
    and: true,
    the: true,
    di: true,
    diamonds: true,
    diamond: true,
    store: true,
    stores: true,
    international: true,
    region: true,
    locations: true,
    location: true,
    shop: true,
    mall: true,
    street: true,
    road: true,
    avenue: true,
    suite: true,
    floor: true,
    level: true,
    plaza: true,
    center: true,
    centre: true
  };

  function levenshteinDistance(a, b) {
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;

    let previousRow = [];
    let currentRow = [];
    for (let columnIndex = 0; columnIndex <= b.length; columnIndex += 1) {
      previousRow[columnIndex] = columnIndex;
    }

    for (let rowIndex = 1; rowIndex <= a.length; rowIndex += 1) {
      currentRow[0] = rowIndex;
      for (let columnIndex = 1; columnIndex <= b.length; columnIndex += 1) {
        const substitutionCost =
          a.charAt(rowIndex - 1) === b.charAt(columnIndex - 1) ? 0 : 1;
        currentRow[columnIndex] = Math.min(
          currentRow[columnIndex - 1] + 1,
          previousRow[columnIndex] + 1,
          previousRow[columnIndex - 1] + substitutionCost
        );
      }
      const swapRow = previousRow;
      previousRow = currentRow;
      currentRow = swapRow;
    }

    return previousRow[b.length];
  }

  function maxLevenshteinForLength(length) {
    if (length <= 3) return 1;
    if (length <= 6) return 2;
    return 3;
  }

  function isFuzzyMatch(query, candidate) {
    if (!query || !candidate) return false;
    if (query === candidate) return false;

    const maxLength = Math.max(query.length, candidate.length);
    const minLength = Math.min(query.length, candidate.length);
    if (maxLength - minLength > maxLevenshteinForLength(minLength)) return false;

    const distance = levenshteinDistance(query, candidate);
    if (distance > maxLevenshteinForLength(minLength)) return false;
    return distance / maxLength <= 0.4;
  }

  function displayWordFromPhrase(phraseDisplay, normalizedWord) {
    const phraseParts = String(phraseDisplay || '').split(/[\s,.\-/]+/);
    for (let partIndex = 0; partIndex < phraseParts.length; partIndex += 1) {
      const phrasePart = phraseParts[partIndex];
      if (normalizeForStoreSearch(phrasePart) === normalizedWord) return phrasePart;
    }
    if (normalizedWord.length <= 2) return normalizedWord.toUpperCase();
    return normalizedWord.charAt(0).toUpperCase() + normalizedWord.slice(1);
  }

  function buildSearchVocabulary(stores) {
    const phraseMap = {};
    const wordMap = {};

    function rememberPhrase(rawValue) {
      const display = String(rawValue || '').trim();
      if (display.length < 3) return;

      const normalizedPhrase = normalizeForStoreSearch(display);
      if (normalizedPhrase.length < 3) return;

      if (!phraseMap[normalizedPhrase] || display.length > phraseMap[normalizedPhrase].length) {
        phraseMap[normalizedPhrase] = display;
      }

      normalizedPhrase.split(' ').forEach(function(normalizedWord) {
        if (normalizedWord.length < 3 || SEARCH_VOCAB_STOP_WORDS[normalizedWord]) return;
        if (!wordMap[normalizedWord]) {
          wordMap[normalizedWord] = displayWordFromPhrase(display, normalizedWord);
        }
      });
    }

    stores.forEach(function(store) {
      rememberPhrase(store.country);
      rememberPhrase(store.region);
      rememberPhrase(store.groupName);
      rememberPhrase(store.locationName);
      rememberPhrase(store.name);
      rememberPhrase(store.addressCityLine);
      String(store.address || '')
        .split(/[\n,]+/)
        .forEach(rememberPhrase);
    });

    return {
      phrases: Object.keys(phraseMap).map(function(normalizedPhrase) {
        return { normalized: normalizedPhrase, display: phraseMap[normalizedPhrase] };
      }),
      words: Object.keys(wordMap).map(function(normalizedWord) {
        return { normalized: normalizedWord, display: wordMap[normalizedWord] };
      })
    };
  }

  function findBestFuzzyEntry(query, entries) {
    let bestEntry = null;
    entries.forEach(function(entry) {
      if (!isFuzzyMatch(query, entry.normalized)) return;
      const distance = levenshteinDistance(query, entry.normalized);
      if (!bestEntry || distance < bestEntry.distance) {
        bestEntry = {
          normalized: entry.normalized,
          display: entry.display,
          distance: distance
        };
      }
    });
    return bestEntry;
  }

  function buildDisplayFromNormalizedTokens(tokens, vocabulary) {
    return tokens
      .map(function(token) {
        if (token.length <= 2) return token.toUpperCase();

        const phraseEntry = vocabulary.phrases.find(function(entry) {
          return entry.normalized === token;
        });
        if (phraseEntry) return phraseEntry.display;

        const wordEntry = vocabulary.words.find(function(entry) {
          return entry.normalized === token;
        });
        if (wordEntry) return wordEntry.display;

        return displayWordFromPhrase(token, token);
      })
      .join(' ');
  }

  function findSearchSuggestion(normalizedQuery, vocabulary) {
    if (!normalizedQuery || normalizedQuery.length < 3) return null;

    const phraseMatch = findBestFuzzyEntry(normalizedQuery, vocabulary.phrases);
    if (phraseMatch) return phraseMatch.display;

    const queryTokens = normalizedQuery.split(' ').filter(Boolean);
    if (!queryTokens.length) return null;

    let correctedAnyToken = false;
    const correctedTokens = queryTokens.map(function(token) {
      if (token.length < 3) return token;

      const exactWord = vocabulary.words.find(function(entry) {
        return entry.normalized === token;
      });
      if (exactWord) return token;

      const fuzzyWord = findBestFuzzyEntry(token, vocabulary.words);
      if (fuzzyWord) {
        correctedAnyToken = true;
        return fuzzyWord.normalized;
      }
      return token;
    });

    if (!correctedAnyToken) return null;

    const correctedQuery = correctedTokens.join(' ');
    if (correctedQuery === normalizedQuery) return null;

    const correctedPhrase = vocabulary.phrases.find(function(entry) {
      return entry.normalized === correctedQuery;
    });
    if (correctedPhrase) return correctedPhrase.display;

    return buildDisplayFromNormalizedTokens(correctedTokens, vocabulary);
  }

  function queryMatchesAnyStore(normalizedQuery) {
    return normalizedStores.some(function(store) {
      return storeSearchTextMatchesQuery(store.searchText || '', normalizedQuery);
    });
  }

  function mergeMetaBrandLists(store) {
    const seenBrandKeys = {};
    const mergedBrandNames = [];
    function addBrandListFromMeta(list) {
      if (!Array.isArray(list)) return;
      list.forEach(function(item) {
        let brandLabel =
          typeof item === 'string' ? item : item && (item.name || item.title);
        if (!brandLabel) return;
        brandLabel = String(brandLabel).trim();
        if (!brandLabel) return;
        const lowercaseKey = brandLabel.toLowerCase();
        if (seenBrandKeys[lowercaseKey]) return;
        seenBrandKeys[lowercaseKey] = true;
        mergedBrandNames.push(brandLabel);
      });
    }
    addBrandListFromMeta(store.jewelry_top_brands);
    addBrandListFromMeta(store.watches_top_brands);
    return mergedBrandNames;
  }

  function descriptionToHtml(desc) {
    if (desc == null || desc === '') return '';
    const descriptionText = String(desc);
    if (/^\s*</.test(descriptionText)) return descriptionText;
    return descriptionText
      .split(/\n\n+/)
      .map(function(para) {
        return (
          '<p>' +
          para
            .split(/\n/)
            .map(function(line) {
              return escapeHtml(line);
            })
            .join('<br>') +
          '</p>'
        );
      })
      .join('');
  }

  function hoursSummaryFromWeek(weekHours) {
    if (!Array.isArray(weekHours) || !weekHours.length) return '';
    const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const today = dayNames[new Date().getDay()];
    const todayScheduleRow = weekHours.find(function(dayHoursRow) {
      return dayHoursRow.day === today;
    });
    return todayScheduleRow && todayScheduleRow.hours && todayScheduleRow.hours !== '—'
      ? todayScheduleRow.hours
      : '';
  }

  function isOpenedOnlyOpeningDateLabel(openingDateDisplay) {
    return /^\s*opened\s*$/i.test(String(openingDateDisplay || '').trim());
  }

  function isOpeningSoonStore(store) {
    const od = (store.openingDate || '').trim();
    return !!od && !isOpenedOnlyOpeningDateLabel(od);
  }

  function extractYearFromOpeningDisplay(openingDateDisplay) {
    const m = /\b(19|20)\d{2}\b/.exec(String(openingDateDisplay || ''));
    return m ? m[0] : '';
  }

  function buildOpeningSoonTagline(openingDateDisplay) {
    const year = extractYearFromOpeningDisplay(openingDateDisplay);
    if (year) return 'Opening soon for ' + year;
    return 'Opening soon';
  }

  function resolveOpeningSoonHoursSummary(store) {
    const summary =
      (store.hours && String(store.hours).trim()) ||
      hoursSummaryFromWeek(store.weekHours || []) ||
      '';
    return summary !== '' ? summary : OPENING_SOON_HOURS_DEFAULT;
  }

  const defaultBrands = ['Mikimoto', 'Piaget', 'Diamonds Intl', 'Rolex', 'Omega', 'Hublot'];

  function isMeaningfulStoreLabel(rawValue) {
    const trimmedValue = String(rawValue == null ? '' : rawValue).trim();
    if (!trimmedValue) return false;
    const normalizedValue = trimmedValue.toLowerCase().replace(/[^a-z0-9]/g, '');
    return (
      normalizedValue !== '' &&
      normalizedValue !== 'na' &&
      normalizedValue !== 'none' &&
      normalizedValue !== 'null' &&
      normalizedValue !== 'nil' &&
      normalizedValue !== 'other' &&
      normalizedValue !== 'undefined'
    );
  }

  function sanitizeStoreLabel(rawValue) {
    if (!isMeaningfulStoreLabel(rawValue)) return '';
    return String(rawValue).trim();
  }

  const normalizedStores = stores.map(function(store, index) {
    let latitude = parseCoord(store.latitude);
    let longitude = parseCoord(store.longitude);
    if (!Number.isFinite(latitude)) latitude = parseCoord(store.lat);
    if (!Number.isFinite(longitude)) {
      longitude = parseCoord(store.lng);
      if (!Number.isFinite(longitude)) longitude = parseCoord(store.long);
    }
    const googleMapsUrl = normalizeGoogleMapsUrl(
      store.google_maps_url || store.maps_url
    );
    const directionsLink = resolveDirectionsLinkFromRawStore(store);
    const hasExplicitCoordinates =
      Number.isFinite(latitude) && Number.isFinite(longitude);
    const mapsUrlForCoords = googleMapsUrl || directionsLink;
    const placeCoordsFromListingUrl =
      mapsUrlForCoords && parseGoogleMapsPlacePinCoordinates(mapsUrlForCoords);
    const viewportCoordsFromUrl =
      mapsUrlForCoords && !placeCoordsFromListingUrl
        ? parseGoogleMapsViewportCoordinates(mapsUrlForCoords)
        : null;
    if (placeCoordsFromListingUrl) {
      latitude = placeCoordsFromListingUrl.lat;
      longitude = placeCoordsFromListingUrl.lng;
    } else if (!hasExplicitCoordinates && viewportCoordsFromUrl) {
      latitude = viewportCoordsFromUrl.lat;
      longitude = viewportCoordsFromUrl.lng;
    }
    const handle = store.handle ? String(store.handle).trim() : '';
    const country = sanitizeStoreLabel(store.country || store.country_name);
    const region = sanitizeStoreLabel(store.region_name || store.region);
    const storesGroupNameRaw = sanitizeStoreLabel(store.stores_group_name || store.group_name);
    const groupName = storesGroupNameRaw || country;
    const address = buildAddressFromMeta(store);
    const hasAddressMetafield =
      typeof store.has_address_metafield === 'boolean'
        ? store.has_address_metafield
        : isMeaningfulStoreLabel(store.address_line_1 || store.address_line_2 || store.address);
    const weekFromMeta = buildWeekHoursFromMeta(store);
    const weekHours =
      Array.isArray(store.weekHours) && store.weekHours.length
        ? store.weekHours
        : weekFromMeta || null;
    const openingDate = formatOpeningDate(store.opening_date || store.openingDate);
    const mergedBrands = mergeMetaBrandLists(store);
    let jewelryBrands = normalizeBrandEntries(store.jewelry_top_brands).slice(0, 16);
    let watchesBrands = normalizeBrandEntries(store.watches_top_brands).slice(0, 16);
    if (!jewelryBrands.length && !watchesBrands.length) {
      if (Array.isArray(store.brands) && store.brands.length) {
        const legacyFlat = normalizeBrandList(store.brands);
        const mid = Math.ceil(legacyFlat.length / 2);
        jewelryBrands = legacyFlat.slice(0, mid).map(function(brandNameString) {
          return { name: brandNameString, image: '' };
        });
        watchesBrands = legacyFlat.slice(mid).map(function(brandNameString) {
          return { name: brandNameString, image: '' };
        });
      }
    }
    const brands =
      mergedBrands.length > 0
        ? mergedBrands.slice(0, 16)
        : Array.isArray(store.brands) && store.brands.length
          ? normalizeBrandList(store.brands).slice(0, 8)
          : defaultBrands.slice(0, 8);
    const rawDesc = store.description || store.description_about_store || '';
    const description = /^\s*</.test(String(rawDesc))
      ? String(rawDesc)
      : sanitizeStoreLabel(rawDesc)
        ? descriptionToHtml(rawDesc)
        : '';
    const collectionUrl = (store.store_collection_link || store.collectionUrl || '').trim();
    const interiorImage = String(
      store.photos_interior || store.interior_image || ''
    ).trim();
    const hoursLine =
      (store.hours && String(store.hours).trim()) ||
      hoursSummaryFromWeek(weekHours || []) ||
      '';

    const normalizedStore = {
      id: store.id || String(index),
      name: (store.name || 'Store').trim(),
      handle: handle,
      address: address,
      hasAddressMetafield: hasAddressMetafield,
      /** City / state / country line from metaobject — best for Maps search/query accuracy */
      addressCityLine: String(store.address_city_line || '').trim(),
      country: country,
      region: region,
      groupName: groupName,
      locationName: sanitizeStoreLabel(store.location_name),
      latitude: latitude,
      longitude: longitude,
      image: store.image || '',
      phone: sanitizeStoreLabel(store.phone),
      email: sanitizeStoreLabel(store.email),
      hours: hoursLine,
      description: description,
      bannerImage:
        interiorImage || store.bannerImage || store.image || '',
      aboutImage: store.aboutImage || store.image || '',
      collectionUrl: collectionUrl,
      googleMapsUrl: googleMapsUrl,
      directionsLink: directionsLink,
      brands: brands,
      jewelryBrands: jewelryBrands,
      watchesBrands: watchesBrands,
      weekHours: weekHours,
      openingDate: openingDate
    };
    normalizedStore.searchText = buildStoreSearchText(normalizedStore);
    return normalizedStore;
  });

  const searchVocabulary = buildSearchVocabulary(normalizedStores);

  const googleMapContainerElement = document.getElementById('store-locator-map');
  const searchInput = document.getElementById('store-locator-search');
  const searchSuggestionEl = document.getElementById('store-locator-search-suggestion');
  const SEARCH_SUGGESTION_LABEL = readStoreLocatorRootDataAttr(
    'data-search-suggestion-label',
    'Did you mean'
  );
  const regionSelect = document.getElementById('store-locator-region');
  const countryFilterList = document.getElementById('store-country-filter-list');
  const groupsContainer = document.getElementById('store-groups');
  const resultsCount = document.getElementById('store-results-count');

  let selectedGroup = 'all';
  let searchTerm = '';
  let storeLocatorScrollY = 0;
  let googleMap;
  let infoWindow;
  let mapMarkerRecords = [];
  let markerRecordByStoreLookupKey = {};
  let isGeocodingInProgress = false;
  let mapRefitDebounceTimer = null;
  let storeLocatorPinIcons = null;
  let storeLocatorAccentMapMarker = null;

  function resetStoreLocatorMapMarkerAccent() {
    if (!storeLocatorAccentMapMarker || !storeLocatorPinIcons) return;
    storeLocatorAccentMapMarker.setIcon(storeLocatorPinIcons.idle);
    storeLocatorAccentMapMarker.setZIndex(99999);
    storeLocatorAccentMapMarker = null;
  }

  function scheduleMapRefitDebounced(delayMs) {
    if (mapRefitDebounceTimer) {
      window.clearTimeout(mapRefitDebounceTimer);
    }
    mapRefitDebounceTimer = window.setTimeout(function() {
      mapRefitDebounceTimer = null;
      applyFilters();
    }, typeof delayMs === 'number' ? delayMs : 50);
  }
  const modalRoot = document.getElementById('store-detail-modal');
  const modalHeroImage = document.getElementById('store-detail-hero-image');
  const modalAboutImage = document.getElementById('store-detail-about-image');
  const modalRegion = document.getElementById('store-detail-region');
  const modalTitle = document.getElementById('store-detail-modal-title');
  const modalHeroAddress = document.getElementById('store-detail-hero-address');
  const modalHeroOpeningBadge = document.getElementById('store-detail-hero-opening-badge');
  const modalDescription = document.getElementById('store-detail-description');
  const modalAddress = document.getElementById('store-detail-address');
  const modalPhone = document.getElementById('store-detail-phone');
  const modalEmail = document.getElementById('store-detail-email');
  const modalHours = document.getElementById('store-detail-hours');
  const modalBrandsJewelry = document.getElementById('store-detail-brands-jewelry');
  const modalBrandsWatches = document.getElementById('store-detail-brands-watches');
  const modalSectionJewelryBrands = document.getElementById('store-detail-section-jewelry-brands');
  const modalSectionWatchBrands = document.getElementById('store-detail-section-watch-brands');
  const modalHoursTable = document.getElementById('store-detail-hours-table');
  const modalHoursSection = modalHoursTable
    ? modalHoursTable.closest('.store-detail-modal__section--hours')
    : null;
  const modalHoursMetaRow = modalHours
    ? modalHours.closest('.store-detail-modal__meta-row')
    : null;
  const modalAddressMetaRow = modalAddress
    ? modalAddress.closest('.store-detail-modal__meta-row')
    : null;
  const modalPhoneMetaRow = modalPhone
    ? modalPhone.closest('.store-detail-modal__meta-row')
    : null;
  const modalEmailMetaRow = modalEmail
    ? modalEmail.closest('.store-detail-modal__meta-row')
    : null;
  const modalMoreRegion = document.getElementById('store-detail-more-region');
  const modalMoreList = document.getElementById('store-detail-more-list');
  const modalDirectionsLink = document.getElementById('store-detail-directions-link');
  const relatedCardTemplate = document.getElementById('store-detail-related-card-template');

  function hasCoords(store) {
    return Number.isFinite(store.latitude) && Number.isFinite(store.longitude);
  }

  function shouldShowMapPin(store) {
    return !!(store && store.hasAddressMetafield);
  }

  function toStoreMarkerLookupKey(id) {
    if (id == null || id === '') return '';
    return String(id);
  }

  function getFilteredStores() {
    const selectedGroupFilter =
      selectedGroup === 'all' ? 'all' : String(selectedGroup || '').trim();
    return normalizedStores.filter(function(store) {
      const storeGroupName = String(store.groupName || '').trim();
      const matchesGroupFilter = selectedGroupFilter === 'all' || storeGroupName === selectedGroupFilter;
      if (!matchesGroupFilter) return false;

      if (!searchTerm) return true;

      return storeSearchTextMatchesQuery(store.searchText || '', searchTerm);
    });
  }

  function findStoreByHandle(handle) {
    if (!handle) return null;
    const normalizedHandle = String(handle).trim();
    return normalizedStores.find(function(store) {
      return String(store.handle || '').trim() === normalizedHandle;
    }) || null;
  }

  function findStoreById(id) {
    if (id == null || id === '') return null;
    const normalizedStoreIdString = String(id);
    return normalizedStores.find(function(store) {
      return String(store.id) === normalizedStoreIdString;
    }) || null;
  }

  function whitespaceCollapsedTrim(value) {
    return String(value == null ? '' : value)
      .replace(/\s+/g, ' ')
      .trim();
  }

  /**
   * When no pasted Maps URL exists, build a stable search string (store name +
   * street + city/state/country via address_city_line) so Google resolves the right place.
   */
  function buildDirectionsFallbackQuery(store) {
    const namePart = whitespaceCollapsedTrim(store.name);
    const fullAddressCollapsed = whitespaceCollapsedTrim(store.address);
    const cityStateCountryLine = whitespaceCollapsedTrim(store.addressCityLine || '');
    const countryPart = whitespaceCollapsedTrim(store.country);

    let placeQuery = '';
    if (namePart && cityStateCountryLine) {
      placeQuery = namePart + ', ' + cityStateCountryLine;
    } else if (namePart && fullAddressCollapsed) {
      if (fullAddressCollapsed.toLowerCase().indexOf(namePart.toLowerCase()) !== -1) {
        placeQuery = fullAddressCollapsed;
      } else {
        placeQuery = namePart + ', ' + fullAddressCollapsed;
      }
    } else if (fullAddressCollapsed) {
      placeQuery = fullAddressCollapsed;
    } else if (namePart && countryPart) {
      placeQuery = namePart + ', ' + countryPart;
    } else if (namePart) {
      placeQuery = namePart;
    } else if (cityStateCountryLine) {
      placeQuery = cityStateCountryLine;
    }

    return placeQuery;
  }

  function buildDirectionsLink(store) {
    return store && store.directionsLink ? store.directionsLink : '';
  }

  function hasDirectionsLink(store) {
    return !!buildDirectionsLink(store);
  }

  function applyModalDirectionsLink(store) {
    if (!modalDirectionsLink) return;
    const directionsHrefForModal = buildDirectionsLink(store);
    if (directionsHrefForModal) {
      modalDirectionsLink.setAttribute('href', directionsHrefForModal);
      modalDirectionsLink.setAttribute('target', '_blank');
      modalDirectionsLink.setAttribute('rel', 'noopener noreferrer');
      modalDirectionsLink.removeAttribute('hidden');
      modalDirectionsLink.removeAttribute('aria-hidden');
    } else {
      modalDirectionsLink.setAttribute('href', '#');
      modalDirectionsLink.setAttribute('hidden', '');
      modalDirectionsLink.setAttribute('aria-hidden', 'true');
    }
  }

  function openModalDirectionsUrl(event) {
    const directionsTrigger = event.target.closest('#store-detail-directions-link');
    if (
      !directionsTrigger ||
      directionsTrigger.hasAttribute('hidden') ||
      shouldDeferStoreDetailClickToBrowser(event)
    ) {
      return false;
    }
    const directionsUrl = directionsTrigger.getAttribute('href') || '';
    if (!directionsUrl || directionsUrl === '#') return false;
    event.preventDefault();
    window.open(directionsUrl, '_blank', 'noopener,noreferrer');
    return true;
  }

  function buildStoreDetailPageUrl(store) {
    const storeHandleOrIdParam = String(store.handle || store.id || '').trim();
    const pageUrl = new URL(window.location.href);
    pageUrl.searchParams.set('store', storeHandleOrIdParam);
    return pageUrl.toString();
  }

  const STORE_CARD_PLACEHOLDER_IMAGE =
    'data:image/svg+xml;charset=utf-8,' +
    encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="720" height="340" viewBox="0 0 720 340">' +
        '<rect fill="#e5e5e5" width="720" height="340"/>' +
        '<text x="360" y="175" fill="#888" font-size="18" font-family="system-ui,sans-serif" text-anchor="middle" dominant-baseline="middle">Store</text>' +
        '</svg>'
    );

  function storeListingFallbackUrl() {
    return STORE_IMAGE_LOGO_FALLBACK || STORE_CARD_PLACEHOLDER_IMAGE;
  }

  function resolveStoreListingImageUrl(maybeRaw) {
    const trimmed =
      maybeRaw != null && String(maybeRaw).trim() !== ''
        ? String(maybeRaw).trim()
        : '';
    if (trimmed) return trimmed;
    return storeListingFallbackUrl();
  }

  function isFallbackStoreListingImageUrl(resolvedUrl) {
    const s = String(resolvedUrl || '');
    return s === STORE_IMAGE_LOGO_FALLBACK || s === STORE_CARD_PLACEHOLDER_IMAGE;
  }

  /** When a store image URL fails to load, try theme logo then the geometric SVG placeholder. */
  function wireStoreListingImageFallback(imgElement, primaryUrl) {
    if (!imgElement) return;
    const primaryTrimmed =
      primaryUrl != null && String(primaryUrl).trim() !== ''
        ? String(primaryUrl).trim()
        : '';
    if (!primaryTrimmed) return;
    if (primaryTrimmed === STORE_CARD_PLACEHOLDER_IMAGE) return;

    imgElement.onerror = function() {
      const stage = imgElement.getAttribute('data-sl-img-fallback') || '';
      if (!stage && STORE_IMAGE_LOGO_FALLBACK) {
        imgElement.setAttribute('data-sl-img-fallback', 'logo');
        imgElement.src = STORE_IMAGE_LOGO_FALLBACK;
        imgElement.classList.add('store-locator-img--placeholder');
        return;
      }
      imgElement.setAttribute('data-sl-img-fallback', 'final');
      imgElement.onerror = null;
      imgElement.src = STORE_CARD_PLACEHOLDER_IMAGE;
      imgElement.classList.add('store-locator-img--placeholder');
    };
  }

  function phoneNumberToTelHref(rawPhoneNumber) {
    const phoneNumberRaw = String(rawPhoneNumber || '').trim();
    if (!phoneNumberRaw) return '#';
    
    const phoneCandidateMatch = phoneNumberRaw.match(/\+?\d[\d\s().-]{5,}/);
    if (!phoneCandidateMatch) return '#';

    const normalizedNumericPhone = phoneCandidateMatch[0]
      .replace(/\s+/g, '')
      .replace(/[^\d+]/g, '')
      .replace(/^\+?(\d.*)$/, '+$1');

    if (!normalizedNumericPhone || normalizedNumericPhone === '+') return '#';

    return 'tel:' + normalizedNumericPhone;
  }

  function buildStoreCardHtml(store) {
    const cardImageUrl = resolveStoreListingImageUrl(store.image);
    const placeholderClass = isFallbackStoreListingImageUrl(cardImageUrl)
      ? ' store-locator-img--placeholder'
      : '';
    const todayHours =
      store.hours ||
      hoursSummaryFromWeek(store.weekHours || []) ||
      '';
    const directionsHref = buildDirectionsLink(store);
    const showDirectionsLink = hasDirectionsLink(store);
    const detailHref = buildStoreDetailPageUrl(store);
    const storeOpeningDate = (store.openingDate || '').trim();
    const openingSoon = isOpeningSoonStore(store);

    let cardHtml =
      '<div class="store-card__media">' +
      (openingSoon
        ? '<span class="store-card-opening-badge">' +
          escapeHtml(OPENING_SOON_BADGE_LABEL) +
          '</span>'
        : '') +
      '<img class="store-card-image' +
      placeholderClass +
      '" src="' +
      escapeHtml(cardImageUrl) +
      '" alt="' +
      escapeHtml(store.name || 'Store') +
      '" width="720" height="340" loading="lazy" decoding="async">' +
      '</div>' +
      '<div class="store-card-body">' +
      '<h4 class="store-card-title">' +
      escapeHtml(store.name || 'Store') +
      '</h4>';

    const locationSubtitle = (store.locationName || '').trim();
    if (locationSubtitle) {
      cardHtml +=
        '<p class="store-card-subtitle">' + escapeHtml(locationSubtitle) + '</p>';
    }

    if (store.address) {
      cardHtml +=
        '<p class="store-card-address">' + escapeHtml(store.address) + '</p>';
    }

    if (store.phone) {
      const phoneEsc = escapeHtml(store.phone);
      cardHtml +=
        '<p class="store-card-contact store-card-contact--phone">' +
        '<a class="store-card-contact-link" href="' +
        escapeHtml(phoneNumberToTelHref(store.phone)) +
        '" aria-label="Call ' +
        phoneEsc +
        '">' +
        '<span class="store-card-contact-link__placeholder">Hover To See Phone Number</span>' +
        '<span class="store-card-contact-link__value">' +
        phoneEsc +
        '</span></a></p>';
    }

    if (store.email) {
      const emailEsc = escapeHtml(store.email);
      cardHtml +=
        '<p class="store-card-contact store-card-contact--email">' +
        '<a class="store-card-contact-link" href="mailto:' +
        emailEsc +
        '" aria-label="Email ' +
        emailEsc +
        '">' +
        '<span class="store-card-contact-link__placeholder">Hover To See Email</span>' +
        '<span class="store-card-contact-link__value">' +
        emailEsc +
        '</span></a></p>';
    }

    if (openingSoon) {
      const hoursLine = resolveOpeningSoonHoursSummary(store);
      const tagline = buildOpeningSoonTagline(storeOpeningDate);
      cardHtml +=
        '<p class="store-card-hours store-card-hours--opening-soon">' +
        '<strong>Today\'s Hours:</strong> ' +
        '<span class="store-card-hours__value">' +
        escapeHtml(hoursLine) +
        '</span></p>' +
        '<hr class="store-card-divider store-card-divider--in-body" role="presentation">' +
        '<p class="store-card-opening-tagline">' +
        escapeHtml(tagline) +
        '</p>';
    } else if (storeOpeningDate && !isOpenedOnlyOpeningDateLabel(storeOpeningDate)) {
      cardHtml +=
        '<p class="store-card-hours store-card-hours--opening">' +
        '<strong>Opening Date:</strong> ' +
        escapeHtml(storeOpeningDate) +
        '</p>';
    } else if (todayHours) {
      cardHtml +=
        '<p class="store-card-hours"><strong>Today\'s Hours:</strong> ' +
        escapeHtml(todayHours) +
        '</p>';
    }

    cardHtml +=
      '<hr class="store-card-divider" role="presentation">' +
      '<div class="store-card-actions">' +
      (showDirectionsLink
        ? '<a href="' +
          escapeHtml(directionsHref) +
          '" class="store-card-text-link store-card-directions" target="_blank" rel="noopener noreferrer">Directions</a>'
        : '') +
      '<a href="' +
      escapeHtml(detailHref) +
      '" class="store-card-text-link store-card-details-link js-open-store-detail" data-store-handle="' +
      escapeHtml(store.handle || '') +
      '" data-store-id="' +
      escapeHtml(String(store.id)) +
      '">Store Details</a>' +
      '</div></div>';

    return cardHtml;
  }

  function getInfoWindowSubtitle(store) {
    const country = (store.country || '').trim();
    const addressLines = String(store.address || '')
      .split(/\r?\n/)
      .map(function(addressLine) {
        return addressLine.trim();
      })
      .filter(Boolean);

    let city = '';
    if (addressLines.length >= 2) {
      let candidateLine = addressLines[addressLines.length - 1];
      if (country && candidateLine.toLowerCase() === country.toLowerCase()) {
        candidateLine = addressLines[addressLines.length - 2];
      }
      city = candidateLine.split(',')[0].trim();
    } else if (addressLines.length === 1) {
      const commaSegments = addressLines[0].split(',').map(function(segment) {
        return segment.trim();
      }).filter(Boolean);
      if (commaSegments.length >= 2 && country && commaSegments[commaSegments.length - 1].toLowerCase() === country.toLowerCase()) {
        city = commaSegments[commaSegments.length - 2];
      } else if (commaSegments.length >= 2) {
        city = commaSegments[commaSegments.length - 1];
      }
    }

    city = (city || '').trim();
    if (country && city.toLowerCase() === country.toLowerCase()) {
      city = '';
    }

    if (city && country) return city + ', ' + country;
    if (country) return country;
    return city;
  }

  function buildInfoWindowHtml(store) {
    const subtitle = getInfoWindowSubtitle(store);
    const metaHtml = subtitle
      ? '<p class="store-locator-iw__meta">' + escapeHtml(subtitle) + '</p>'
      : '';
    return (
      '<div class="store-locator-iw">' +
      '<p class="store-locator-iw__name">' +
      escapeHtml(store.name || 'Store') +
      '</p>' +
      metaHtml +
      '<a href="' +
      escapeHtml(buildStoreDetailPageUrl(store)) +
      '" class="store-locator-iw__link js-store-locator-iw-detail" data-store-handle="' +
      escapeHtml(store.handle || '') +
      '" data-store-id="' +
      escapeHtml(String(store.id)) +
      '">View Details \u2192</a>' +
      '</div>'
    );
  }

  function showStoreInfoWindow(store, marker) {
    if (!infoWindow || !googleMap || !marker || !window.google || !window.google.maps) return;
    if (storeLocatorPinIcons && storeLocatorAccentMapMarker !== marker) {
      resetStoreLocatorMapMarkerAccent();
      marker.setIcon(storeLocatorPinIcons.active);
      marker.setZIndex(window.google.maps.Marker.MAX_ZINDEX + 40);
      storeLocatorAccentMapMarker = marker;
    }
    infoWindow.setContent(buildInfoWindowHtml(store));
    infoWindow.open({ map: googleMap, anchor: marker, shouldFocus: false });
    window.google.maps.event.addListenerOnce(infoWindow, 'domready', function() {
      const storeIdString = String(store.id);
      const detailLinks = document.querySelectorAll('a.js-store-locator-iw-detail');
      let matchingDetailLink = null;
      for (let linkIndex = 0; linkIndex < detailLinks.length; linkIndex++) {
        if (detailLinks[linkIndex].getAttribute('data-store-id') === storeIdString) {
          matchingDetailLink = detailLinks[linkIndex];
          break;
        }
      }
      if (!matchingDetailLink) return;
      matchingDetailLink.addEventListener('click', function(e) {
        if (shouldDeferStoreDetailClickToBrowser(e)) return;
        e.preventDefault();
        infoWindow.close();
        openStoreModal(store);
      });
    });
  }

  function shouldDeferStoreDetailClickToBrowser(event) {
    return (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey
    );
  }

  function wireBrandCarousel(carouselRoot) {
    const brandsViewport = carouselRoot.querySelector('.store-detail-modal__brands-viewport');
    const previousArrow = carouselRoot.querySelector('.store-detail-modal__brands-arrow--prev');
    const nextArrow = carouselRoot.querySelector('.store-detail-modal__brands-arrow--next');
    const brandsDotsNav = carouselRoot.querySelector('.store-detail-modal__brands-dots');
    if (!brandsViewport || !previousArrow || !nextArrow) return;

    let carouselPaginationPageCount = 0;

    function scrollToCarouselPage(desiredPageIndex) {
      const viewportWidthPx = brandsViewport.clientWidth;
      const maxScrollLeftPx = Math.max(
        0,
        brandsViewport.scrollWidth - brandsViewport.clientWidth
      );
      const targetScrollLeftPx = Math.min(
        desiredPageIndex * viewportWidthPx,
        maxScrollLeftPx
      );
      brandsViewport.scrollTo({ left: targetScrollLeftPx, behavior: 'smooth' });
    }

    function buildOrSyncCarouselPaginationDots() {
      if (!brandsDotsNav) return;

      const viewportWidthPx = brandsViewport.clientWidth;
      const stripScrollWidthPx = brandsViewport.scrollWidth;
      const isSinglePageStrip = stripScrollWidthPx <= viewportWidthPx + 2;
      const nextPageCount = isSinglePageStrip
        ? 1
        : Math.max(1, Math.ceil(stripScrollWidthPx / viewportWidthPx));

      if (nextPageCount <= 1) {
        carouselPaginationPageCount = 0;
        brandsDotsNav.hidden = true;
        brandsDotsNav.innerHTML = '';
        return;
      }

      brandsDotsNav.hidden = false;

      if (nextPageCount !== carouselPaginationPageCount) {
        carouselPaginationPageCount = nextPageCount;
        brandsDotsNav.innerHTML = '';
        for (let pageIdx = 0; pageIdx < nextPageCount; pageIdx++) {
          const carouselDotButton = document.createElement('button');
          carouselDotButton.type = 'button';
          carouselDotButton.className = 'store-detail-modal__brands-dot';
          carouselDotButton.setAttribute(
            'aria-label',
            'Brand logos page ' + (pageIdx + 1) + ' of ' + nextPageCount
          );
          const capturedPageIdx = pageIdx;
          carouselDotButton.addEventListener('click', function() {
            scrollToCarouselPage(capturedPageIdx);
          });
          brandsDotsNav.appendChild(carouselDotButton);
        }
      }

      const scrollLeftPx = brandsViewport.scrollLeft;
      const maxScrollLeftPx = Math.max(
        0,
        stripScrollWidthPx - viewportWidthPx
      );
      const pageStridePx = Math.max(1, viewportWidthPx);
      let activePageIdx = Math.floor((scrollLeftPx + pageStridePx * 0.15) / pageStridePx);
      if (activePageIdx < 0) activePageIdx = 0;
      if (activePageIdx >= nextPageCount) activePageIdx = nextPageCount - 1;

      const nearEndTolerancePx = 4;
      if (maxScrollLeftPx > 0 && scrollLeftPx >= maxScrollLeftPx - nearEndTolerancePx) {
        activePageIdx = nextPageCount - 1;
      }

      const carouselDotButtons = brandsDotsNav.querySelectorAll('.store-detail-modal__brands-dot');
      for (let dotIdx = 0; dotIdx < carouselDotButtons.length; dotIdx++) {
        const isActiveCarouselDot = dotIdx === activePageIdx;
        carouselDotButtons[dotIdx].classList.toggle(
          'store-detail-modal__brands-dot--active',
          isActiveCarouselDot
        );
        if (isActiveCarouselDot) {
          carouselDotButtons[dotIdx].setAttribute('aria-current', 'true');
        } else {
          carouselDotButtons[dotIdx].removeAttribute('aria-current');
        }
      }
    }

    function syncCarouselArrows() {
      const hasHorizontalOverflow = brandsViewport.scrollWidth > brandsViewport.clientWidth + 2;
      carouselRoot.classList.toggle(
        'store-detail-modal__brands-carousel--scrollable',
        hasHorizontalOverflow
      );
      if (!hasHorizontalOverflow) {
        previousArrow.setAttribute('aria-hidden', 'true');
        nextArrow.setAttribute('aria-hidden', 'true');
        previousArrow.hidden = true;
        nextArrow.hidden = true;
        buildOrSyncCarouselPaginationDots();
        return;
      }
      previousArrow.hidden = false;
      nextArrow.hidden = false;
      previousArrow.removeAttribute('aria-hidden');
      nextArrow.removeAttribute('aria-hidden');
      const scrolledToStart = brandsViewport.scrollLeft <= 2;
      const scrolledToEnd =
        brandsViewport.scrollLeft + brandsViewport.clientWidth >= brandsViewport.scrollWidth - 2;
      previousArrow.disabled = scrolledToStart;
      nextArrow.disabled = scrolledToEnd;
      buildOrSyncCarouselPaginationDots();
    }

    brandsViewport.addEventListener('scroll', syncCarouselArrows, { passive: true });
    previousArrow.addEventListener('click', function() {
      brandsViewport.scrollBy({ left: -brandsViewport.clientWidth, behavior: 'smooth' });
    });
    nextArrow.addEventListener('click', function() {
      brandsViewport.scrollBy({ left: brandsViewport.clientWidth, behavior: 'smooth' });
    });

    const brandLogoImages = brandsViewport.querySelectorAll('.store-detail-modal__brand-img');
    for (let imageIndex = 0; imageIndex < brandLogoImages.length; imageIndex++) {
      brandLogoImages[imageIndex].addEventListener('load', syncCarouselArrows, { passive: true });
    }

    const carouselResizeObserver =
      typeof ResizeObserver !== 'undefined'
        ? new ResizeObserver(function() {
            carouselPaginationPageCount = 0;
            syncCarouselArrows();
          })
        : null;
    if (carouselResizeObserver) carouselResizeObserver.observe(brandsViewport);

    syncCarouselArrows();
    window.requestAnimationFrame(syncCarouselArrows);
    window.requestAnimationFrame(function() {
      syncCarouselArrows();
    });
  }

  function renderBrandsInto(brandsContainer, brandsSource) {
    if (!brandsContainer) return;
    brandsContainer.innerHTML = '';
    const normalizedBrandEntries = normalizeBrandEntries(brandsSource);
    if (!normalizedBrandEntries.length) {
      const emptyStateParagraph = document.createElement('p');
      emptyStateParagraph.className = 'store-detail-modal__brands-empty';
      emptyStateParagraph.textContent = 'No brands listed.';
      brandsContainer.appendChild(emptyStateParagraph);
      return;
    }

    const carouselRootEl = document.createElement('div');
    carouselRootEl.className = 'store-detail-modal__brands-carousel';
    carouselRootEl.setAttribute('role', 'region');
    carouselRootEl.setAttribute('aria-label', 'Brand logos');

    const prevArrowButton = document.createElement('button');
    prevArrowButton.type = 'button';
    prevArrowButton.className =
      'store-detail-modal__brands-arrow store-detail-modal__brands-arrow--prev';
    prevArrowButton.setAttribute('aria-label', 'Previous brands');
    prevArrowButton.innerHTML =
      '<span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg></span>';

    const nextArrowButton = document.createElement('button');
    nextArrowButton.type = 'button';
    nextArrowButton.className =
      'store-detail-modal__brands-arrow store-detail-modal__brands-arrow--next';
    nextArrowButton.setAttribute('aria-label', 'Next brands');
    nextArrowButton.innerHTML =
      '<span aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></span>';

    const brandLogoStripViewport = document.createElement('div');
    brandLogoStripViewport.className = 'store-detail-modal__brands-viewport';

    normalizedBrandEntries.forEach(function(brandDisplayEntry) {
      const brandCell = document.createElement('div');
      brandCell.className = 'store-detail-modal__brand';
      if (brandDisplayEntry.image) {
        const brandLogoImg = document.createElement('img');
        brandLogoImg.className = 'store-detail-modal__brand-img';
        brandLogoImg.src = brandDisplayEntry.image;
        brandLogoImg.alt = brandDisplayEntry.name || '';
        brandLogoImg.loading = 'lazy';
        brandLogoImg.decoding = 'async';
        brandCell.appendChild(brandLogoImg);
      } else {
        brandCell.classList.add('store-detail-modal__brand--text');
        brandCell.textContent = brandDisplayEntry.name || '';
      }
      brandLogoStripViewport.appendChild(brandCell);
    });

    const carouselTrackInner = document.createElement('div');
    carouselTrackInner.className = 'store-detail-modal__brands-carousel-inner';

    carouselTrackInner.appendChild(prevArrowButton);
    carouselTrackInner.appendChild(brandLogoStripViewport);
    carouselTrackInner.appendChild(nextArrowButton);
    carouselRootEl.appendChild(carouselTrackInner);

    const brandsPaginationDotsNav = document.createElement('div');
    brandsPaginationDotsNav.className = 'store-detail-modal__brands-dots';
    brandsPaginationDotsNav.setAttribute('role', 'navigation');
    brandsPaginationDotsNav.setAttribute('aria-label', 'Brand logos pages');
    brandsPaginationDotsNav.hidden = true;
    carouselRootEl.appendChild(brandsPaginationDotsNav);

    brandsContainer.appendChild(carouselRootEl);
    wireBrandCarousel(carouselRootEl);
  }

  function setBrandSectionCollapsed(sectionEl, collapsed) {
    if (!sectionEl) return;
    sectionEl.classList.toggle('store-detail-modal__section--brands-collapsed', collapsed);
    sectionEl.hidden = collapsed;
    sectionEl.setAttribute('aria-hidden', collapsed ? 'true' : 'false');
  }

  function populateStoreModalBrands(store) {
    const jewelryBrandsSectionEl =
      modalSectionJewelryBrands ||
      (modalBrandsJewelry && modalBrandsJewelry.closest('section'));
    const watchBrandsSectionEl =
      modalSectionWatchBrands ||
      (modalBrandsWatches && modalBrandsWatches.closest('section'));
    const jewelryBrandCount = normalizeBrandEntries(store.jewelryBrands).length;
    const watchBrandCount = normalizeBrandEntries(store.watchesBrands).length;

    if (!jewelryBrandCount && !watchBrandCount) {
      if (modalBrandsJewelry) modalBrandsJewelry.innerHTML = '';
      if (modalBrandsWatches) modalBrandsWatches.innerHTML = '';
      setBrandSectionCollapsed(jewelryBrandsSectionEl, true);
      setBrandSectionCollapsed(watchBrandsSectionEl, true);
      return;
    }

    setBrandSectionCollapsed(jewelryBrandsSectionEl, !jewelryBrandCount);
    setBrandSectionCollapsed(watchBrandsSectionEl, !watchBrandCount);

    if (jewelryBrandCount) {
      renderBrandsInto(modalBrandsJewelry, store.jewelryBrands);
    } else if (modalBrandsJewelry) {
      modalBrandsJewelry.innerHTML = '';
    }

    if (watchBrandCount) {
      renderBrandsInto(modalBrandsWatches, store.watchesBrands);
    } else if (modalBrandsWatches) {
      modalBrandsWatches.innerHTML = '';
    }
  }

  function getTodayWeekdayName() {
    const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    return dayNames[new Date().getDay()];
  }

  function setHoursSectionVisibility(isVisible) {
    if (!modalHoursSection) return;
    modalHoursSection.hidden = !isVisible;
    modalHoursSection.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
  }

  function setModalMetaRowVisibility(metaRowEl, isVisible) {
    if (!metaRowEl) return;
    metaRowEl.hidden = !isVisible;
    metaRowEl.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
  }

  function setHoursMetaRowVisibility(isVisible) {
    setModalMetaRowVisibility(modalHoursMetaRow, isVisible);
  }

  function renderWeekHours(weekHours) {
    if (!modalHoursTable) return;
    modalHoursTable.innerHTML = '';
    const definedDayRows = (Array.isArray(weekHours) ? weekHours : []).filter(function(daySchedule) {
      const trimmedHoursText = daySchedule && daySchedule.hours ? String(daySchedule.hours).trim() : '';
      return trimmedHoursText !== '' && trimmedHoursText !== '—';
    });
    if (!definedDayRows.length) {
      setHoursSectionVisibility(false);
      return;
    }
    setHoursSectionVisibility(true);
    const todayWeekdayName = getTodayWeekdayName();
    definedDayRows.forEach(function(daySchedule) {
      const hoursTableRow = document.createElement('tr');
      if (daySchedule.day === todayWeekdayName) {
        hoursTableRow.className = 'store-detail-modal__hours-row--today';
      }
      hoursTableRow.innerHTML = '<td>' + escapeHtml(daySchedule.day || '') + '</td><td>' + escapeHtml(daySchedule.hours || '') + '</td>';
      modalHoursTable.appendChild(hoursTableRow);
    });
  }

  function shuffleArrayInPlace(items) {
    for (let index = items.length - 1; index > 0; index--) {
      const randomIndex = Math.floor(Math.random() * (index + 1));
      const temporaryItem = items[index];
      items[index] = items[randomIndex];
      items[randomIndex] = temporaryItem;
    }
    return items;
  }

  function buildRelatedRegionLabel(store) {
    if (!store) return '';
    if (isMeaningfulStoreLabel(store.region)) {
      return String(store.region).trim() + ' Region';
    }
    const trimmedGroupName = sanitizeStoreLabel(store.groupName);
    if (trimmedGroupName) return trimmedGroupName;
    const trimmedCountry = sanitizeStoreLabel(store.country);
    if (trimmedCountry) return trimmedCountry + ' Region';
    return '';
  }

  function renderMoreLocations(activeStore) {
    if (!modalMoreList || !relatedCardTemplate) return;
    modalMoreList.innerHTML = '';

    const moreLocationsSection = modalMoreList.closest(
      '.store-detail-modal__section--more-locations'
    );
    const relatedLocationCardCount = 3;

    const useRegionForRelatedMatch = isMeaningfulStoreLabel(activeStore.region);
    const activeStoreGroupName = sanitizeStoreLabel(activeStore.groupName);

    let relatedStoresInSameScope = null;
    if (useRegionForRelatedMatch) {
      relatedStoresInSameScope = normalizedStores.filter(function(store) {
        return (
          store.id !== activeStore.id &&
          isMeaningfulStoreLabel(store.region) &&
          String(store.region).trim() === String(activeStore.region).trim()
        );
      });
    } else if (activeStoreGroupName) {
      relatedStoresInSameScope = normalizedStores.filter(function(store) {
        return (
          store.id !== activeStore.id &&
          String(store.groupName || '').trim() === activeStoreGroupName
        );
      });
    }

    let relatedStorePool =
      relatedStoresInSameScope && relatedStoresInSameScope.length
        ? relatedStoresInSameScope.slice()
        : normalizedStores.filter(function(store) {
            return store.id !== activeStore.id && store.country === activeStore.country;
          });

    let pickedWorldwideShuffle = false;
    if (!relatedStorePool.length) {
      relatedStorePool = normalizedStores.filter(function(store) {
        return store.id !== activeStore.id;
      });
      shuffleArrayInPlace(relatedStorePool);
      pickedWorldwideShuffle = true;
    }

    const pickedStoreIdLookup = {};
    pickedStoreIdLookup[String(activeStore.id)] = true;
    const relatedStoresToShow = [];
    relatedStorePool.forEach(function(candidateStore) {
      if (relatedStoresToShow.length >= relatedLocationCardCount) return;
      const candidateIdKey = String(candidateStore.id);
      if (pickedStoreIdLookup[candidateIdKey]) return;
      pickedStoreIdLookup[candidateIdKey] = true;
      relatedStoresToShow.push(candidateStore);
    });

    if (relatedStoresToShow.length < relatedLocationCardCount) {
      const filler = normalizedStores.filter(function(store) {
        return !pickedStoreIdLookup[String(store.id)];
      });
      shuffleArrayInPlace(filler);
      filler.forEach(function(candidateStore) {
        if (relatedStoresToShow.length >= relatedLocationCardCount) return;
        const candidateIdKey = String(candidateStore.id);
        if (pickedStoreIdLookup[candidateIdKey]) return;
        pickedStoreIdLookup[candidateIdKey] = true;
        relatedStoresToShow.push(candidateStore);
      });
    }

    if (!relatedStoresToShow.length) {
      if (moreLocationsSection) {
        moreLocationsSection.hidden = true;
        moreLocationsSection.setAttribute('aria-hidden', 'true');
      }
      return;
    }

    if (modalMoreRegion && pickedWorldwideShuffle) {
      modalMoreRegion.textContent = '';
      modalMoreRegion.hidden = true;
      modalMoreRegion.setAttribute('hidden', '');
    }

    if (moreLocationsSection) {
      moreLocationsSection.hidden = false;
      moreLocationsSection.setAttribute('aria-hidden', 'false');
    }

    modalMoreList.classList.remove('store-detail-modal__more-list--empty');

    relatedStoresToShow.forEach(function(store) {
      const relatedCardRoot = relatedCardTemplate.content.firstElementChild.cloneNode(true);
      const relatedImage = relatedCardRoot.querySelector('.store-detail-modal__related-image');
      const relatedTitle = relatedCardRoot.querySelector('.store-detail-modal__related-title');
      const relatedAddress = relatedCardRoot.querySelector('.store-detail-modal__related-address');
      const relatedDetailLink = relatedCardRoot.querySelector('.js-open-related-store');

      const relatedSrc = resolveStoreListingImageUrl(store.image);
      relatedImage.src = relatedSrc;
      relatedImage.alt = store.name || 'Store image';
      relatedImage.classList.toggle(
        'store-locator-img--placeholder',
        isFallbackStoreListingImageUrl(relatedSrc)
      );
      wireStoreListingImageFallback(relatedImage, store.image);
      relatedTitle.textContent = store.name || 'Store';
      relatedAddress.textContent = store.address || '';
      relatedDetailLink.setAttribute('href', buildStoreDetailPageUrl(store));
      relatedDetailLink.setAttribute('data-store-handle', store.handle || '');
      relatedDetailLink.setAttribute('data-store-id', String(store.id));

      modalMoreList.appendChild(relatedCardRoot);
    });
  }

  function applyStoreLocatorModalClosed() {
    if (!modalRoot) return;
    modalRoot.classList.remove('is-open');
    modalRoot.setAttribute('aria-hidden', 'true');
    storeLocatorPageRoot.classList.remove('store-locator-root--hidden');
    window.scrollTo(0, storeLocatorScrollY);
  }

  function closeStoreModal() {
    if (!modalRoot || !modalRoot.classList.contains('is-open')) return;
    const url = new URL(window.location.href);
    if (url.searchParams.has('store')) {
      url.searchParams.delete('store');
      // Sync state with URL so history doesn’t retain a “detail” state object after closing.
      window.history.replaceState({ storeLocatorList: true }, '', url.toString());
    }
    applyStoreLocatorModalClosed();
  }

  function openStoreModal(store, openOptions) {
    if (!store || !modalRoot) return;
    openOptions = openOptions || {};
    if (infoWindow) infoWindow.close();
    resetStoreLocatorMapMarkerAccent();

    const wasModalClosed = !modalRoot.classList.contains('is-open');
    if (wasModalClosed) {
      storeLocatorScrollY = window.scrollY || window.pageYOffset || 0;
      storeLocatorPageRoot.classList.add('store-locator-root--hidden');
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });

    modalTitle.textContent = store.name || 'Store';
    let regionPillLabel = '';
    if (isMeaningfulStoreLabel(store.region)) {
      regionPillLabel = String(store.region).trim();
    } else {
      const groupLabel = sanitizeStoreLabel(store.groupName);
      const countryLabel = sanitizeStoreLabel(store.country);
      if (groupLabel) {
        regionPillLabel = groupLabel;
      } else if (countryLabel) {
        regionPillLabel = countryLabel + ' Region';
      }
    }
    if (modalRegion) {
      if (regionPillLabel) {
        modalRegion.textContent = regionPillLabel;
        modalRegion.hidden = false;
        modalRegion.removeAttribute('hidden');
      } else {
        modalRegion.textContent = '';
        modalRegion.hidden = true;
        modalRegion.setAttribute('hidden', '');
      }
    }
    modalHeroAddress.textContent = getInfoWindowSubtitle(store) || '';
    const addressForModal =
      store.address != null && String(store.address).trim() !== ''
        ? String(store.address)
        : '';
    if (addressForModal) {
      modalAddress.textContent = addressForModal;
      setModalMetaRowVisibility(modalAddressMetaRow, true);
    } else {
      modalAddress.textContent = '';
      setModalMetaRowVisibility(modalAddressMetaRow, false);
    }
    modalDescription.innerHTML = store.description || '';
    const storeOpeningDate = (store.openingDate || '').trim();
    const todayHoursStr =
      store.hours ||
      hoursSummaryFromWeek(store.weekHours || []) ||
      '';
    if (isOpeningSoonStore(store)) {
      const hoursLine = resolveOpeningSoonHoursSummary(store);
      const tagline = buildOpeningSoonTagline(storeOpeningDate);
      modalHours.innerHTML =
        '<span class="store-detail-modal__hours-opening-soon">' +
        '<span class="store-detail-modal__hours-opening-soon-line">' +
        '<strong>Today\'s Hours:</strong> ' +
        '<span class="store-detail-modal__hours-value-soft">' +
        escapeHtml(hoursLine) +
        '</span></span>' +
        '<span class="store-detail-modal__opening-tagline">' +
        escapeHtml(tagline) +
        '</span></span>';
      setHoursMetaRowVisibility(true);
    } else if (
      storeOpeningDate &&
      !isOpenedOnlyOpeningDateLabel(storeOpeningDate)
    ) {
      modalHours.innerHTML =
        '<strong>Opening Date:</strong> ' + escapeHtml(storeOpeningDate);
      setHoursMetaRowVisibility(true);
    } else if (todayHoursStr) {
      modalHours.innerHTML =
        '<strong>Today\'s Hours:</strong> ' + escapeHtml(todayHoursStr);
      setHoursMetaRowVisibility(true);
    } else {
      modalHours.innerHTML = '';
      setHoursMetaRowVisibility(false);
    }

    const phoneForModal = String(store.phone || '').trim();
    if (phoneForModal) {
      const phoneHref = phoneNumberToTelHref(phoneForModal);
      modalPhone.innerHTML =
        '<a href="' + escapeHtml(phoneHref) + '">' + escapeHtml(phoneForModal) + '</a>';
      setModalMetaRowVisibility(modalPhoneMetaRow, true);
    } else {
      modalPhone.textContent = '';
      modalPhone.innerHTML = '';
      setModalMetaRowVisibility(modalPhoneMetaRow, false);
    }

    const emailForModal = String(store.email || '').trim();
    if (emailForModal) {
      modalEmail.innerHTML =
        '<a href="mailto:' + escapeHtml(emailForModal) + '">' + escapeHtml(emailForModal) + '</a>';
      setModalMetaRowVisibility(modalEmailMetaRow, true);
    } else {
      modalEmail.textContent = '';
      modalEmail.innerHTML = '';
      setModalMetaRowVisibility(modalEmailMetaRow, false);
    }

    modalHeroImage.onerror = null;
    modalHeroImage.removeAttribute('data-sl-img-fallback');
    modalAboutImage.onerror = null;
    modalAboutImage.removeAttribute('data-sl-img-fallback');

    const modalHeroResolved = resolveStoreListingImageUrl(
      store.bannerImage || store.image
    );
    const modalAboutResolved = resolveStoreListingImageUrl(
      store.aboutImage || store.image
    );
    modalHeroImage.src = modalHeroResolved;
    modalHeroImage.alt = store.name || 'Store image';
    modalHeroImage.classList.toggle(
      'store-locator-img--placeholder',
      isFallbackStoreListingImageUrl(modalHeroResolved)
    );
    wireStoreListingImageFallback(modalHeroImage, store.bannerImage || store.image);
    modalAboutImage.src = modalAboutResolved;
    modalAboutImage.alt = store.name || 'Store image';
    modalAboutImage.classList.toggle(
      'store-locator-img--placeholder',
      isFallbackStoreListingImageUrl(modalAboutResolved)
    );
    wireStoreListingImageFallback(modalAboutImage, store.aboutImage || store.image);

    applyModalHeroCollectionLink(store.collectionUrl);
    applyModalAppointmentLink(emailForModal);
    applyModalDirectionsLink(store);
    if (modalMoreRegion) {
      const relatedRegionLabel = buildRelatedRegionLabel(store);
      if (relatedRegionLabel) {
        modalMoreRegion.textContent = relatedRegionLabel;
        modalMoreRegion.hidden = false;
        modalMoreRegion.removeAttribute('hidden');
      } else {
        modalMoreRegion.textContent = '';
        modalMoreRegion.hidden = true;
        modalMoreRegion.setAttribute('hidden', '');
      }
    }

    populateStoreModalBrands(store);
    if (modalHeroOpeningBadge) {
      if (isOpeningSoonStore(store)) {
        modalHeroOpeningBadge.textContent = OPENING_SOON_BADGE_LABEL;
        modalHeroOpeningBadge.removeAttribute('hidden');
      } else {
        modalHeroOpeningBadge.textContent = '';
        modalHeroOpeningBadge.setAttribute('hidden', '');
      }
    }
    // Show the week hours table whenever per-day hours exist, including for
    // "opening soon" listings that still have schedule data.
    renderWeekHours(store.weekHours || []);
    renderMoreLocations(store);

    modalRoot.classList.add('is-open');
    modalRoot.setAttribute('aria-hidden', 'false');

    const storeQueryValue = store.handle || String(store.id);
    if (
      storeQueryValue &&
      !openOptions.skipHistoryPush
    ) {
      const detailUrl = new URL(window.location.href);
      detailUrl.searchParams.set('store', storeQueryValue);
      window.history.pushState(
        { storeLocatorDetail: true, storeQuery: storeQueryValue },
        '',
        detailUrl.toString()
      );
    }
  }

  function syncStoreDetailModalWithHistory() {
    if (!modalRoot) return;
    // After popstate, some engines (notably Safari) haven’t updated location yet in the same turn.
    const detailParam =
      new URL(window.location.href).searchParams.get('store') ||
      '';

    const storeFromUrl =
      detailParam &&
      (findStoreByHandle(detailParam) || findStoreById(detailParam));

    if (detailParam && storeFromUrl) {
      openStoreModal(storeFromUrl, { skipHistoryPush: true });
      return;
    }

    if (modalRoot.classList.contains('is-open')) {
      applyStoreLocatorModalClosed();
    }
  }

  function onStoreLocatorPopstate() {
    window.setTimeout(syncStoreDetailModalWithHistory, 0);
  }

  window.addEventListener('popstate', onStoreLocatorPopstate);

  function locationCountLabel(locationCount) {
    return locationCount === 1 ? '1 Location' : locationCount + ' Locations';
  }

  function groupFilterButtonHtml(dataGroup, isActive, nameText, count) {
    const activeClass = isActive ? ' is-active' : '';
    const countText = locationCountLabel(count);
    return (
      '<li><button class="store-country-filter' +
      activeClass +
      '" data-country="' +
      escapeHtml(dataGroup) +
      '" type="button">' +
      '<span class="store-country-filter__name">' +
      escapeHtml(nameText) +
      '</span>' +
      '<span class="store-country-filter__count">' +
      escapeHtml(countText) +
      '</span></button></li>'
    );
  }

  function renderGroupFilters() {
    const groupCounts = {};
    normalizedStores.forEach(function(store) {
      const groupKey = sanitizeStoreLabel(store.groupName);
      if (!groupKey) return;
      groupCounts[groupKey] = (groupCounts[groupKey] || 0) + 1;
    });

    const groupNames = Object.keys(groupCounts).sort(function(a, b) {
      return a.localeCompare(b);
    });

    if (selectedGroup !== 'all' && groupNames.indexOf(selectedGroup) === -1) {
      selectedGroup = 'all';
    }

    if (countryFilterList) {
      const totalCount = normalizedStores.length;
      let groupFilterMarkup = groupFilterButtonHtml('all', selectedGroup === 'all', 'All Locations', totalCount);
      groupNames.forEach(function(groupName) {
        groupFilterMarkup += groupFilterButtonHtml(groupName, selectedGroup === groupName, groupName, groupCounts[groupName] || 0);
      });
      countryFilterList.innerHTML = groupFilterMarkup;
    }

    if (regionSelect) {
      regionSelect.innerHTML = '';
      const allOpt = document.createElement('option');
      allOpt.value = 'all';
      allOpt.textContent = 'All Locations';
      regionSelect.appendChild(allOpt);
      groupNames.forEach(function(groupName) {
        const opt = document.createElement('option');
        opt.value = groupName;
        opt.textContent = groupName;
        regionSelect.appendChild(opt);
      });
      regionSelect.value = selectedGroup;
      if (regionSelect.value !== selectedGroup) {
        selectedGroup = 'all';
        regionSelect.value = 'all';
      }
    }
  }

  function groupStoresByGroupName(filteredStores) {
    const groups = {};
    filteredStores.forEach(function(store) {
      const groupNameKey = sanitizeStoreLabel(store.groupName);
      if (!groups[groupNameKey]) groups[groupNameKey] = [];
      groups[groupNameKey].push(store);
    });
    return groups;
  }

  function updateResultsCount(filteredStoreTotal) {
    if (!resultsCount) return;
    const locationUnitWord = filteredStoreTotal === 1 ? 'location' : 'locations';
    const countTextElement = resultsCount.querySelector('.store-locator-count-line__text');
    const resultsSummaryMessage =
      filteredStoreTotal + ' ' + locationUnitWord + ' found';
    if (countTextElement) {
      countTextElement.textContent = resultsSummaryMessage;
    } else {
      resultsCount.textContent = resultsSummaryMessage;
    }
  }

  function renderStoreGroups(filteredStores) {
    groupsContainer.innerHTML = '';
    updateResultsCount(filteredStores.length);

    if (!filteredStores.length) {
      groupsContainer.innerHTML = '<div class="store-empty">No stores found for your filters.</div>';
      return;
    }

    const grouped = groupStoresByGroupName(filteredStores);
    const groupKeys = Object.keys(grouped).sort(function(a, b) {
      return a.localeCompare(b);
    });

    const pinIconSvg = '<svg class="store-group-title__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>';

    groupKeys.forEach(function(groupName) {
      const groupSection = document.createElement('section');
      groupSection.className = 'store-group';

      const storesInGroup = grouped[groupName];
      const locationCount = storesInGroup.length;
      const countLabel = locationCount === 1 ? '1 Location' : locationCount + ' Locations';

      if (groupName) {
        const title = document.createElement('h3');
        title.className = 'store-group-title';

        const titleMain = document.createElement('span');
        titleMain.className = 'store-group-title__main';
        titleMain.innerHTML = pinIconSvg + '<span class="store-group-title__name">' + escapeHtml(groupName) + '</span>';

        const titleCount = document.createElement('span');
        titleCount.className = 'store-group-title__count';
        titleCount.textContent = countLabel;

        title.appendChild(titleMain);
        title.appendChild(titleCount);
        groupSection.appendChild(title);
      }

      const cardGrid = document.createElement('div');
      cardGrid.className = 'store-card-grid';

      storesInGroup.forEach(function(store) {
        const card = document.createElement('article');
        card.className =
          'store-card' + (isOpeningSoonStore(store) ? ' store-card--opening-soon' : '');
        card.setAttribute('data-store-id', store.id);
        card.setAttribute('data-store-country', store.country);
        card.setAttribute('data-store-group', store.groupName || '');
        card.setAttribute('data-store-name', store.name.toLowerCase());

        card.innerHTML = buildStoreCardHtml(store);
        const cardImg = card.querySelector('.store-card-image');
        wireStoreListingImageFallback(cardImg, store.image);

        card.addEventListener('mouseenter', function() {
          card.classList.add('is-hovered');
          const markerRecord = markerRecordByStoreLookupKey[toStoreMarkerLookupKey(store.id)];
          if (markerRecord && markerRecord.marker && googleMap && infoWindow) {
            showStoreInfoWindow(store, markerRecord.marker);
          }
        });

        card.addEventListener('mouseleave', function() {
          card.classList.remove('is-hovered');
        });

        cardGrid.appendChild(card);
      });

      groupSection.appendChild(cardGrid);
      groupsContainer.appendChild(groupSection);
    });
  }

  function fitMapToVisibleMarkers(visibleMarkers) {
    if (!googleMap || !window.google || !window.google.maps) return;
    if (!visibleMarkers.length) {
      googleMap.setCenter({ lat: 20, lng: 0 });
      googleMap.setZoom(2);
      return;
    }

    if (visibleMarkers.length === 1) {
      googleMap.setCenter(visibleMarkers[0].getPosition());
      googleMap.setZoom(isGeocodingInProgress ? 3 : 14);
      return;
    }

    const bounds = new window.google.maps.LatLngBounds();
    visibleMarkers.forEach(function(marker) {
      bounds.extend(marker.getPosition());
    });
    googleMap.fitBounds(bounds, 32);
  }

  function updateMarkerVisibility(filteredStores) {
    if (!googleMap || !window.google || !window.google.maps) return;

    const visibleStoreIds = {};
    filteredStores.forEach(function(store) {
      visibleStoreIds[toStoreMarkerLookupKey(store.id)] = true;
    });

    const visibleMarkers = [];
    mapMarkerRecords.forEach(function(markerRecord) {
      const shouldShowMarker = !!visibleStoreIds[toStoreMarkerLookupKey(markerRecord.store.id)];
      markerRecord.marker.setVisible(shouldShowMarker);
      if (shouldShowMarker) visibleMarkers.push(markerRecord.marker);
    });

    window.requestAnimationFrame(function() {
      fitMapToVisibleMarkers(visibleMarkers);
    });
  }

  function updateSearchSuggestion(rawSearchInput, filteredStoreTotal) {
    if (!searchSuggestionEl) return;

    const normalizedInput = normalizeForStoreSearch(rawSearchInput);
    if (!normalizedInput || normalizedInput.length < 3 || filteredStoreTotal > 0) {
      searchSuggestionEl.hidden = true;
      searchSuggestionEl.innerHTML = '';
      return;
    }

    const suggestedDisplay = findSearchSuggestion(normalizedInput, searchVocabulary);
    if (!suggestedDisplay) {
      searchSuggestionEl.hidden = true;
      searchSuggestionEl.innerHTML = '';
      return;
    }

    const suggestedNormalized = normalizeForStoreSearch(suggestedDisplay);
    if (
      !suggestedNormalized ||
      suggestedNormalized === normalizedInput ||
      !queryMatchesAnyStore(suggestedNormalized)
    ) {
      searchSuggestionEl.hidden = true;
      searchSuggestionEl.innerHTML = '';
      return;
    }

    searchSuggestionEl.hidden = false;
    searchSuggestionEl.innerHTML =
      escapeHtml(SEARCH_SUGGESTION_LABEL) +
      ' <button type="button" class="store-locator-search-suggestion__link" data-suggestion="' +
      escapeHtml(suggestedDisplay) +
      '">' +
      escapeHtml(suggestedDisplay) +
      '</button>?';
  }

  function applyFilters() {
    const filtered = getFilteredStores();
    renderStoreGroups(filtered);
    updateMarkerVisibility(filtered);
    updateSearchSuggestion(searchInput ? searchInput.value : '', filtered.length);
  }

  renderGroupFilters();

  if (searchInput) {
    searchInput.addEventListener('input', function(event) {
      searchTerm = normalizeForStoreSearch(event.target.value);
      applyFilters();
    });
  }

  if (searchSuggestionEl) {
    searchSuggestionEl.addEventListener('click', function(event) {
      const suggestionButton = event.target.closest('.store-locator-search-suggestion__link');
      if (!suggestionButton || !searchInput) return;

      const suggestedValue = suggestionButton.getAttribute('data-suggestion') || '';
      if (!suggestedValue) return;

      searchInput.value = suggestedValue;
      searchTerm = normalizeForStoreSearch(suggestedValue);
      applyFilters();
      searchInput.focus();
    });
  }

  if (countryFilterList) {
    countryFilterList.addEventListener('click', function(event) {
      const trigger = event.target.closest('.store-country-filter');
      if (!trigger) return;

      selectedGroup = trigger.getAttribute('data-country') || 'all';

      const allButtons = countryFilterList.querySelectorAll('.store-country-filter');
      allButtons.forEach(function(button) {
        button.classList.remove('is-active');
      });
      trigger.classList.add('is-active');

      if (regionSelect) {
        regionSelect.value = selectedGroup;
      }

      applyFilters();
    });
  }

  if (regionSelect) {
    regionSelect.addEventListener('change', function() {
      selectedGroup = regionSelect.value || 'all';

      if (countryFilterList) {
        const allButtons = countryFilterList.querySelectorAll('.store-country-filter');
        allButtons.forEach(function(button) {
          const isMatch = button.getAttribute('data-country') === selectedGroup;
          button.classList.toggle('is-active', isMatch);
        });
      }

      applyFilters();
    });
  }

  if (groupsContainer) {
    groupsContainer.addEventListener('click', function(event) {
      const trigger = event.target.closest('.js-open-store-detail');
      if (!trigger) return;
      if (shouldDeferStoreDetailClickToBrowser(event)) return;
      event.preventDefault();
      const handle = trigger.getAttribute('data-store-handle');
      const storeId = trigger.getAttribute('data-store-id');
      const selectedStore = findStoreByHandle(handle) || findStoreById(storeId);
      if (selectedStore) {
        openStoreModal(selectedStore);
      }
    });
  }

  if (modalRoot) {
    modalRoot.addEventListener('click', function(event) {
      if (openModalDirectionsUrl(event)) return;

      const relatedTrigger = event.target.closest('.js-open-related-store');
      if (relatedTrigger) {
        if (!shouldDeferStoreDetailClickToBrowser(event)) {
          event.preventDefault();
          const nextHandle = relatedTrigger.getAttribute('data-store-handle');
          const nextId = relatedTrigger.getAttribute('data-store-id');
          const nextStore = findStoreByHandle(nextHandle) || findStoreById(nextId);
          if (nextStore) {
            openStoreModal(nextStore);
          }
        }
        return;
      }

      const closeTrigger = event.target.closest('[data-modal-close]');
      if (closeTrigger) {
        closeStoreModal();
      }
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && modalRoot.classList.contains('is-open')) {
        closeStoreModal();
      }
    });
  }

  window.initStoreLocatorMap = function() {
    if (!window.google || !window.google.maps || !googleMapContainerElement) return;

    googleMap = new window.google.maps.Map(googleMapContainerElement, {
      zoom: 3,
      center: { lat: 20, lng: 0 },
      mapTypeId: window.google.maps.MapTypeId.ROADMAP,
      zoomControl: true,
      mapTypeControl: true,
      mapTypeControlOptions: {
        style: window.google.maps.MapTypeControlStyle.DROPDOWN_MENU
      },
      streetViewControl: true,
      fullscreenControl: true,
      scaleControl: true
    });

    infoWindow = new window.google.maps.InfoWindow({
      maxWidth: 300,
      pixelOffset: new window.google.maps.Size(0, -6)
    });
    window.google.maps.event.addListener(infoWindow, 'closeclick', function() {
      resetStoreLocatorMapMarkerAccent();
    });
    mapMarkerRecords = [];
    markerRecordByStoreLookupKey = {};

    function buildStoreLocatorMarkerCircleIcon(options) {
      const scalePx = typeof options.scale === 'number' ? options.scale : 11;
      const strokeW = typeof options.strokeWeight === 'number' ? options.strokeWeight : 3;
      return {
        path: window.google.maps.SymbolPath.CIRCLE,
        fillColor: '#D32323',
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: strokeW,
        scale: scalePx
      };
    }

    const markerIconIdle = buildStoreLocatorMarkerCircleIcon({ scale: 11, strokeWeight: 3 });
    const markerIconActive = buildStoreLocatorMarkerCircleIcon({ scale: 14, strokeWeight: 3 });
    storeLocatorPinIcons = { idle: markerIconIdle, active: markerIconActive };

    function geocodeAddressQuery(store) {
      const fallback = buildDirectionsFallbackQuery(store);
      if (fallback) return fallback;
      let addressQuery = (store.address || '').trim().replace(/\s+/g, ' ');
      if (!addressQuery) return '';
      const countrySuffix = (store.country || '').trim();
      if (
        countrySuffix &&
        addressQuery.toLowerCase().indexOf(countrySuffix.toLowerCase()) === -1
      ) {
        addressQuery += ', ' + countrySuffix;
      }
      return addressQuery;
    }

    function smoothZoomIn(map, targetZoom) {
      const z = map.getZoom();
      if (typeof z !== 'number' || z >= targetZoom) return;
      window.google.maps.event.addListenerOnce(map, 'zoom_changed', function() {
        smoothZoomIn(map, targetZoom);
      });
      map.setZoom(z + 1);
    }

    function zoomMapToMarker(marker) {
      if (!googleMap || !marker || !window.google || !window.google.maps) return;
      const position = marker.getPosition();
      if (!position) return;

      window.google.maps.event.addListenerOnce(googleMap, 'idle', function onMapIdleAfterPan() {
        const currentZoom = googleMap.getZoom();
        const targetZoom = 16;
        if (typeof currentZoom === 'number' && currentZoom < targetZoom) {
          smoothZoomIn(googleMap, targetZoom);
        }
      });

      googleMap.panTo(position);
    }

    function registerMapMarker(store, latitude, longitude) {
      if (!shouldShowMapPin(store)) return;
      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return;
      store.latitude = latitude;
      store.longitude = longitude;
      const mapPin = new window.google.maps.Marker({
        position: { lat: latitude, lng: longitude },
        map: googleMap,
        title: store.name || 'Store',
        icon: markerIconIdle,
        optimized: false,
        zIndex: 99999
      });

      mapPin.addListener('click', function() {
        zoomMapToMarker(mapPin);
        showStoreInfoWindow(store, mapPin);
      });

      const mapMarkerRecord = { store: store, marker: mapPin };
      mapMarkerRecords.push(mapMarkerRecord);
      markerRecordByStoreLookupKey[toStoreMarkerLookupKey(store.id)] = mapMarkerRecord;
    }

    normalizedStores.forEach(function(store) {
      if (shouldShowMapPin(store) && hasCoords(store)) {
        registerMapMarker(store, store.latitude, store.longitude);
      }
    });

    function finalizeMapMarkers() {
      window.requestAnimationFrame(function() {
        applyFilters();
      });
    }

    finalizeMapMarkers();

    const pendingGeocode = normalizedStores.filter(function(store) {
      return shouldShowMapPin(store) && !hasCoords(store) && geocodeAddressQuery(store);
    });

    if (!pendingGeocode.length) {
      isGeocodingInProgress = false;
      return;
    }

    isGeocodingInProgress = true;
    applyFilters();

    const geocoder = new window.google.maps.Geocoder();
    const GEOCODE_CONCURRENCY = 8;
    let geocodeIndex = 0;
    let activeGeocodeCount = 0;

    function finishGeocodingPipeline() {
      isGeocodingInProgress = false;
      if (mapRefitDebounceTimer) {
        window.clearTimeout(mapRefitDebounceTimer);
        mapRefitDebounceTimer = null;
      }
      finalizeMapMarkers();
    }

    function geocodeOne() {
      if (geocodeIndex >= pendingGeocode.length) {
        if (activeGeocodeCount === 0) {
          finishGeocodingPipeline();
        }
        return;
      }
      const store = pendingGeocode[geocodeIndex];
      geocodeIndex += 1;
      activeGeocodeCount += 1;
      geocoder.geocode({ address: geocodeAddressQuery(store) }, function(results, status) {
        if (status === 'OK' && results && results[0] && results[0].geometry && results[0].geometry.location) {
          const geometryLocation = results[0].geometry.location;
          const resolvedLatitude =
            typeof geometryLocation.lat === 'function' ? geometryLocation.lat() : geometryLocation.lat;
          const resolvedLongitude =
            typeof geometryLocation.lng === 'function' ? geometryLocation.lng() : geometryLocation.lng;
          registerMapMarker(store, resolvedLatitude, resolvedLongitude);
          scheduleMapRefitDebounced(120);
        }
        activeGeocodeCount -= 1;
        if (geocodeIndex < pendingGeocode.length) {
          geocodeOne();
        } else if (activeGeocodeCount === 0) {
          finishGeocodingPipeline();
        }
      });
    }

    const initialBatchSize = Math.min(GEOCODE_CONCURRENCY, pendingGeocode.length);
    for (let workerIndex = 0; workerIndex < initialBatchSize; workerIndex++) {
      geocodeOne();
    }
  };

  if (window.google && window.google.maps) {
    window.initStoreLocatorMap();
  } else {
    applyFilters();
  }

  const landingLocatorUrl = new URL(window.location.href);
  const storeQueryOnLanding =
    landingLocatorUrl.searchParams.get('store');

  let storeMatchedFromLandingUrl = null;
  if (storeQueryOnLanding) {
    storeMatchedFromLandingUrl =
      findStoreByHandle(storeQueryOnLanding) ||
      findStoreById(storeQueryOnLanding);
  }

  if (storeQueryOnLanding && storeMatchedFromLandingUrl) {
    landingLocatorUrl.searchParams.delete('store');
    window.history.replaceState(
      { storeLocatorList: true },
      '',
      landingLocatorUrl.toString()
    );

    const urlWithLandingStoreDetail = new URL(window.location.href);
    urlWithLandingStoreDetail.searchParams.set('store', storeQueryOnLanding);
    window.history.pushState(
      {
        storeLocatorDetail: true,
        storeQuery: storeQueryOnLanding
      },
      '',
      urlWithLandingStoreDetail.toString()
    );

    openStoreModal(storeMatchedFromLandingUrl, { skipHistoryPush: true });
  }
})();
